import { render, staticRenderFns } from "./checkbox-defaultValue-editor.vue?vue&type=template&id=59bd6ae8&scoped=true"
import script from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./checkbox-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd6ae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59bd6ae8')) {
      api.createRecord('59bd6ae8', component.options)
    } else {
      api.reload('59bd6ae8', component.options)
    }
    module.hot.accept("./checkbox-defaultValue-editor.vue?vue&type=template&id=59bd6ae8&scoped=true", function () {
      api.rerender('59bd6ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-checkbox/checkbox-defaultValue-editor.vue"
export default component.exports